import { render, staticRenderFns } from "./shop-order.vue?vue&type=template&id=f4349bf8&scoped=true"
import script from "./shop-order.vue?vue&type=script&lang=js"
export * from "./shop-order.vue?vue&type=script&lang=js"
import style0 from "./shop-order.vue?vue&type=style&index=0&id=f4349bf8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4349bf8",
  null
  
)

export default component.exports